module.exports = __webpack_public_path__ + "static/media/apps.582b0885.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/apps.svg
// module id = 889
// module chunks = 0